// @flow
import { connect } from 'react-redux';
import messageActions from '../../../actions/messageActions';
import Messages from '../Messages';
import type { Props } from '../Messages';

type OwnProps = $ReadOnly<{
    showAll?: boolean,
    disableForm?: boolean,

    onClose?: () => void
}>;

const mapDispatchToProps = {
    sendMessage: messageActions.sendMessage
};

export default connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps)(Messages);